<script setup lang="ts">
import { PropType } from 'vue'

/* Types */
import { Category } from '@/types/api/api-v3/category'

/* Components */
import MainCategoryListItem from '@/components/Main/MainCategoryListItem.vue'
const IconArrowLeft = defineAsyncComponent(
  () => import('@/components/Icons/IconArrowLeft.vue'),
)
const IconArrowRight = defineAsyncComponent(
  () => import('@/components/Icons/ArrowRight.vue'),
)

const props = defineProps({
  simpleCategories: {
    required: true,
    type: Array as PropType<Category[]>,
  },
  isCategoryPage: {
    type: Boolean,
    required: false,
  },
})

const sale = ref<Category>({
  icon: '/main-category-sale.webp',
  image: '/main-category-sale.webp',
  is_filter: false,
  is_japan: false,
  name: 'Акции',
  path: '/sales/',
  slug: 'sales',
})

const currentCategory = ref<number | null>(null)

const findCategoryIndex = (categorySlug: string) => {
  currentCategory.value = props.simpleCategories.findIndex(
    (category) => category.slug === categorySlug,
  )
}
</script>

<template>
  <nav
    itemscope
    itemtype="http://schema.org/SiteNavigationElement"
    class="category"
  >
    <!-- Список категорий для главной страницы  -->
    <section v-if="!isCategoryPage" class="category__list">
      <!-- Захардкоженная категория акции на фронте-->
      <main-category-list-item :category="sale" />

      <main-category-list-item
        v-for="(category, index) in simpleCategories"
        :key="index"
        :category="category"
        class="categories-item"
      />
    </section>
    <!-- Список категорий для страницы отдельной категории  -->
    <v-slide-group
      v-else
      v-model="currentCategory"
      show-arrows
      center-active
      :prev-icon="IconArrowLeft"
      :next-icon="IconArrowRight"
    >
      <!-- Захардкоженная категория акции на фронте-->
      <main-category-list-item
        :category="sale"
        :is-category-page="isCategoryPage"
      />
      <main-category-list-item
        v-for="(category, index) in simpleCategories"
        :key="index"
        :category="category"
        :is-category-page="isCategoryPage"
        @is-category-active="findCategoryIndex(category.slug)"
      />
    </v-slide-group>
  </nav>
</template>

<style lang="scss" scoped>
.category {
  &__list {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 10px;

    @include media('>=tablet') {
      grid-template-columns: repeat(4, 1fr);
      gap: 20px;
    }

    :deep(.categories-item__title) {
      white-space: normal;
    }
  }
  .categories-item-page:first-child {
    margin-left: 15px;
  }
  .categories-item-page:last-child {
    margin-right: 15px;
  }
}
:deep() {
  .categories-item__title {
    white-space: nowrap;
  }

  .v-slide-group {
    position: relative;
    overflow: unset;
  }

  .v-slide-group__prev,
  .v-slide-group__next {
    position: absolute;
    top: 0;
    z-index: 1;
    min-width: 35px !important;
    height: 100%;
    &--disabled {
      display: none;
    }
    .v-icon__component {
      width: 6px;
      height: 11px;
      path {
        fill: #2c2f39;
      }
    }
  }
  .v-slide-group__next {
    right: 0;
    background: linear-gradient(
      270deg,
      #fff 0%,
      rgba(255, 255, 255, 0.5) 91.67%
    );
  }
  .v-slide-group__prev {
    left: 0;
    background: linear-gradient(
      90deg,
      #fff 0%,
      rgba(255, 255, 255, 0.5) 91.67%
    );
  }
}
</style>
